
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-featured-content-view-mode__wrapper{
    color:var(--brand-neutral-white);
    width:100%;
    display:flex;
    flex-direction:column;
    row-gap:1rem;
    padding:2rem 0;
  }

    .se-featured-content-view-mode__wrapper:hover{
      outline:2px solid white;
    }

    .se-featured-content-view-mode__wrapper:hover a{
        text-decoration:underline;
        color:inherit;
        width:100%;
      }
  .se-featured-content-view-mode__eyebrow{
    color:inherit;
    letter-spacing:0.5px;
    padding-left:0.5rem;
    text-transform:uppercase;
  }
  @media (min-width: 768px){
  .se-featured-content-view-mode__eyebrow{
      padding:0 1rem
  }
    }
  .se-featured-content-view-mode__title{
    color:inherit;
    padding:0 0.5rem;
    font-size:var(--fs-lg-mobile);
    font-weight:var(--fw-medium);
    font-family:var(--ff-dmsans);
  }
  .se-featured-content-view-mode__title:hover{
      text-decoration:underline;
    }
  @media (min-width: 768px){
  .se-featured-content-view-mode__title{
      padding:0 1rem;
      font-size:var(--fs-xl)
  }
    }
  .se-featured-content-view-mode__date,
  .se-featured-content-view-mode__content{
    color:inherit;
    font-size:var(--fs-sm-mobile);
    padding-left:0.5rem;
  }
  @media (min-width: 768px){
  .se-featured-content-view-mode__date,
  .se-featured-content-view-mode__content{
      padding:0 1rem;
      font-size:var(--fs-sm)
  }
    }
`;